import { RootState } from 'redux/store'

export const selectUserDetails = (state: RootState) => state.user.userDetails

export const selectUserStatus = (state: RootState) => state.user.status

export const selectUserError = (state: RootState) => state.user.error
